import {
  Component,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from "@angular/core";
import { VAIconRegistryService, close } from "@va/core-library/icons";

@Component({
  selector: "app-left-tab-modal-design",
  templateUrl: "./left-tab-modal-design.component.html",
  styleUrls: ["./left-tab-modal-design.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LeftTabModalDesignComponent {
  @Input() isModalOpen: boolean;
  @Input() title: string;
  @Input() tabDetails: any;
  @Input() selectedTabIndex: number;
  @Input() periodSettingsContent;
  @Input()
  btnTemplate: TemplateRef<any>;
  @Input() showClose = true;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([close]);
  }
  ngOnChanges() {
    //if modal is closed return
    if (!this.isModalOpen) {
      return;
    }
    this.selectedTabIndex = 1;
  }

  closeModal() {
    this.onClose.emit(true);
    this.selectedTabIndex = 1;
  }
}
